// extracted by mini-css-extract-plugin
export var container = "_ug-0";
export var table = "_ug-2";
export var tableWrapper = "_ug-1";